<template>
  <main class="w-full h-full fixed flex flex-col z-0">
    <div class="absolute top-0 left-0 w-full h-full z-10">
      <div class="w-full h-third flex justify-between items-center">
        <div id="close" class="spinner relative w-1/3 lg:w-1/6 p-4 lg:p-8">
          <img
            @mousemove="changeCursor('MENU')"
            @mouseleave="changeCursor('')"
            alt="menu"
            class="
              lg:cursor-none
              origin-center
              h-48
              w-full
              object-contain
              relative
              z-10
            "
            src="@/assets/logos/tsm-menu.svg"
          />
          <div
            id="closeInner"
            class="absolute top-0 left-0 w-full h-full z-0"
          ></div>
        </div>
        <div class="relative w-1/3 lg:w-1/6 p-4 lg:p-8"></div>
        <router-link
          :to="{ name: 'news' }"
          id="news"
          class="spinner relative w-1/3 lg:w-1/6 p-4 lg:p-8"
        >
          <img
            @mousemove="changeCursor('NEWS')"
            @mouseleave="changeCursor('')"
            alt="news"
            class="origin-center h-48 w-full object-contain relative z-10"
            src="@/assets/logos/tsm-news.svg"
          />
          <div
            id="newsInner"
            class="absolute top-0 left-0 w-full h-full z-0"
          ></div>
        </router-link>
      </div>
      <div class="w-full h-third flex justify-between items-center">
        <router-link
          :to="{ name: 'artists' }"
          id="artists"
          class="spinner w-1/3 lg:w-1/6 p-4 lg:p-8 relative"
        >
          <img
            @mousemove="changeCursor('ARTISTS')"
            @mouseleave="changeCursor('')"
            alt="artists"
            class="origin-center h-48 w-full object-contain relative z-10"
            src="@/assets/logos/tsm-artists.svg"
          />
          <div
            id="artistsInner"
            class="absolute top-0 left-0 w-full h-full z-0"
          ></div>
        </router-link>
        <router-link
          :to="{ name: 'home' }"
          id="logo2"
          class="
            spinner
            pointer-events-none
            md:pointer-events-auto
            absolute
            top-1/2
            left-1/2
            transform
            -translate-x-1/2 -translate-y-1/2
            w-full
            md:w-33vw
          "
        >
          <img
            @mousemove="changeCursor('THE SOMETHING MACHINE')"
            @mouseleave="changeCursor('')"
            alt="the something machine"
            class="
              origin-center
              h-full
              md:h-33vw
              w-full
              object-contain
              relative
              z-10
              p-4
              lg:p-8
            "
            :src="logo"
          />
        </router-link>
        <router-link
          :to="{ name: 'media' }"
          id="media"
          class="spinner w-1/3 lg:w-1/6 p-4 lg:p-8 relative"
        >
          <img
            @mousemove="changeCursor('MEDIA')"
            @mouseleave="changeCursor('')"
            alt="media"
            class="origin-center h-48 w-full object-contain relative z-10"
            src="@/assets/logos/tsm-media.svg"
          />
          <div
            id="mediaInner"
            class="absolute top-0 left-0 w-full h-full z-0"
          ></div>
        </router-link>
      </div>
      <div class="w-full h-third flex justify-between items-center">
        <router-link
          :to="{ name: 'program' }"
          id="program"
          class="spinner relative w-1/3 lg:w-1/6 p-4 lg:p-8"
        >
          <img
            @mousemove="changeCursor('PROGRAM')"
            @mouseleave="changeCursor('')"
            alt="program"
            class="origin-center h-48 w-full object-contain relative z-10"
            src="@/assets/logos/tsm-program.svg"
          />
          <div
            id="programInner"
            class="absolute top-0 left-0 w-full h-full z-0"
          ></div>
        </router-link>
        <div class="relative w-1/3 lg:w-1/6 p-4 lg:p-8"></div>
        <router-link
          :to="{ name: 'info' }"
          id="info"
          class="spinner relative w-1/3 lg:w-1/6 p-4 lg:p-8"
        >
          <img
            @mousemove="changeCursor('INFO')"
            @mouseleave="changeCursor('')"
            alt="info"
            class="origin-center h-48 w-full object-contain relative z-10"
            src="@/assets/logos/tsm-info.svg"
          />
          <div
            id="infoInner"
            class="absolute top-0 left-0 w-full h-full z-0"
          ></div>
        </router-link>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "home",
  metaInfo() {
    return {
      title: this.site.title,
      titleTemplate: null,
    };
  },
  data() {
    return {
      logo: "./public/tsm1.svg",
    };
  },
  mounted() {
    this.randomLogo();
  },
  computed: mapState(["site"]),
  methods: {
    randomLogo() {
      let random = Math.floor(Math.random() * 3) + 1;
      this.logo = `./public/tsm${random}.svg`;
    },
    changeCursor(msg) {
      this.$root.$emit("changeCursor", msg);
    },
  },
};
</script>
